/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AssessmentQueryAssessmentOwner extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("AssessmentQueryAssessmentOwner");
    }

    getFixupPrototypeFunction() { return AssessmentQueryAssessmentOwner.fixupPrototype; }

    static newInstance(model: Partial<AssessmentQueryAssessmentOwner>): AssessmentQueryAssessmentOwner {
        let obj = Object.assign(new AssessmentQueryAssessmentOwner(), model);
        AssessmentQueryAssessmentOwner.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AssessmentQueryAssessmentOwner>): AssessmentQueryAssessmentOwner {
        if (!model) return null;
        return AssessmentQueryAssessmentOwner.newInstance(<AssessmentQueryAssessmentOwner> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AssessmentQueryAssessmentOwner) {
        if (!obj) return;

        models.AssessmentQueryAssessmentOwner.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AssessmentQueryAssessmentOwner): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AssessmentQueryAssessmentOwner.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Owners of assessment
     */
    assessment_owners: Array<string>;

}
